import React, { useState } from 'react'
import { Card } from 'adl'
import styled from 'styled-components'
import useInterval from 'utility/useInterval'

const ads = [
  require('images/marketing/ad-credit.png'),
  require('images/marketing/ad-covid.png'),
  require('images/marketing/ad-90-day.png'),
  require('images/marketing/ad-spring.png'),
  require('images/marketing/ad-stimulus.png'),
  require('images/marketing/ad-student.png')
]

const Dot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background-color: ${props =>
    props.active ? props.theme.colors.interactive : props.theme.colors.gray200};
  margin: 4px;
  transition: background-color 400ms ease;
`

const Pager = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  position: absolute;
  bottom: 8px;
  left: 0;
  right: 0;
`

export default () => {
  const [slide, setSlide] = useState(0)

  useInterval(() => {
    let next = slide + 1
    if (next >= ads.length) {
      next = 0
    }
    setSlide(next)
  }, 3000)

  return (
    <Card>
      <img
        alt={`Ad placement #${slide + 1}`}
        src={ads[slide]}
        style={{ display: 'block' }}
        width="100%"
      />
      <Pager>
        {ads.map((ad, index) => (
          <Dot active={index === slide} />
        ))}
      </Pager>
    </Card>
  )
}
